export enum TipoRecapitoCartaceoEnum {
  CARTACEO = <any>"CARTACEO",
}
